import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useUnpublishExperience() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      experienceId,
    }: {
      experienceId: number;
      hotelId: number;
    }) => {
      return apiMutation('POST', {
        path: ENDPOINTS.unpublishExperience,
        params: { id: experienceId.toString() },
      }) as Promise<void>;
    },
    onSuccess: (_, { experienceId, hotelId }) => {
      message.success(`Activity #${experienceId} saved`);
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.experiences, { hotelId }],
        exact: false,
      });
    },
    onError: (_, { experienceId }) => {
      message.error(`Error while modifying activity #${experienceId}`);
    },
  });
}
